/**
 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#l2shinsuishin
 * @type {Assumptionflood}
 * 洪水浸水想定区域（想定最大規模）
 */
module.exports = class Assumptionflood {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '洪水浸水想定区域の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/flood.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#l2shinsuishin'
      }
    ];
  }
}
